export default __webpack_public_path__ + "static/media/viewBar.fe67414f.svg";